const LoadingScreen = () => {
    return <div className="loading-container">
        <img src="/configurations/lp-loader.png" alt=""/></div>
}
export default LoadingScreen;
